import styled from "@emotion/styled";
import { Color } from "../../../constants/colors";
import { globalRadius } from "../../../constants/sizes";

export const GridPickerContainerStyled = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: stretch;
  width: 100%;
  max-width: calc(100vw - 64px);
  background-color: ${Color.background};

  border: 1px solid ${Color.secondaryBackground};

  border-radius: ${globalRadius}px;
  overflow-x: auto;
`;
